import { render } from "./TransitaireDashboardPage.vue?vue&type=template&id=3c9ba003&ts=true"
import script from "./TransitaireDashboardPage.vue?vue&type=script&lang=ts"
export * from "./TransitaireDashboardPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__